import {Controller} from '@hotwired/stimulus';

/**
 * Page ouverte dans une fenêtre fancybox (`layouts/fancyframe.html.twig`) : la fait fermer par la page qui
 * l'a ouverte, et lui signale un enregistrement.
 *
 *   <button type="button" {{ stimulus_action('fancyframe', 'close') }}>Annuler</button>
 *   <div {{ stimulus_controller('fancyframe', {saved: 'cle.produit_ajoute' | trans}) }}></div>
 *
 * Il émet sur l'iframe, donc dans la page parente, `fancyframe:close`, ou `fancyframe:saved`
 * (`detail.message`) dès qu'il se connecte avec la value `saved`. `interface.js` y ferme la fenêtre ; après
 * `fancyframe:saved`, il recharge la page parente, sauf si un de ses écouteurs a appelé
 * `preventDefault()` pour mettre à jour lui-même ce qu'elle affiche (et confirmer `detail.message` par un
 * toast). Hors d'une iframe, `saved` ne fait rien, et `close` ferme la fancybox inline de la page qui le porte
 * (création d'une structure).
 */
export default class extends Controller {
  static values = {saved: String};

  connect() {
    if (this.hasSavedValue) {
      this.#notify('saved', {message: this.savedValue});
    }
  }

  close() {
    this.dispatch('close', {target: window.frameElement ?? this.element});
  }

  #notify(name, detail = {}) {
    const frame = window.frameElement;

    if (frame) {
      this.dispatch(name, {target: frame, detail});
    }
  }
}
